import React, { useCallback, useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    label: 'Why Qtap?',
    href: '#why-qtap'
  }, {
    label: 'Patented',
    href: '#patented'
  }, {
    label: 'Benefits',
    href: '#benefits'
  }, {
    label: 'Testimonials',
    href: '#testimonials'
  }, {
    label: 'Shop',
    href: 'https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt',
    external: true
  }];
  const handleNavClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    // Small delay to let the menu close, then scroll
    setTimeout(() => {
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 150);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-darkest/95 backdrop-blur-sm border-b border-white/10 py-3 md:py-4' : 'bg-transparent py-4 md:py-6'}`} data-id="element-307">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-308">
        {/* Mobile Header: hamburger | logo | Order Now button */}
        <div className="flex md:hidden items-center justify-between" data-id="element-309">
          <button className="text-white p-2 -ml-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-310">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-311" /> : <MenuIcon className="w-6 h-6" data-id="element-312" />}
          </button>

          <a href="#" className="absolute left-1/2 -translate-x-1/2" data-id="element-313">
            <img src="https://cdn.magicpatterns.com/uploads/rX3SBp63zs47X13CcgwCHd/IMG_2082.png" alt="Qtap" className="h-10 w-auto brightness-0 invert" data-id="element-314" />
          </a>

          {/* Order Now button on mobile */}
          <a href="https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt" target="_blank" rel="noopener noreferrer" className="bg-brand-cyan hover:bg-brand-sky text-brand-darkest font-bold text-xs py-2 px-4 rounded-full transition-all" data-id="element-315">
            Order Now
          </a>
        </div>

        {/* Desktop Header: logo left, links right */}
        <div className="hidden md:flex items-center justify-between" data-id="element-316">
          <a href="#" className="flex items-center cursor-pointer" data-id="element-317">
            <img src="https://cdn.magicpatterns.com/uploads/rX3SBp63zs47X13CcgwCHd/IMG_2082.png" alt="Qtap" className="h-14 w-auto brightness-0 invert" data-id="element-318" />
          </a>

          <div className="flex items-center gap-6 lg:gap-8" data-id="element-319">
            {navLinks.map(link => <a key={link.href} href={link.href} target={link.external ? '_blank' : undefined} rel={link.external ? 'noopener noreferrer' : undefined} className="text-sm font-medium text-gray-300 hover:text-brand-cyan transition-colors" data-id="element-320">
                {link.label}
              </a>)}
            <a href="https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt" target="_blank" rel="noopener noreferrer" className="bg-brand-cyan hover:bg-brand-sky text-brand-darkest font-bold py-2 px-6 rounded-full transition-all hover:shadow-[0_0_15px_rgba(0,212,255,0.5)]" data-id="element-321">
              Order Now
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-322">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2
      }} className="md:hidden bg-brand-darkest/95 backdrop-blur-sm border-b border-white/10 overflow-hidden" data-id="element-323">
            <div className="px-4 py-5 flex flex-col gap-3" data-id="element-324">
              {navLinks.map(link => <a key={link.href} href={link.href} target={link.external ? '_blank' : undefined} rel={link.external ? 'noopener noreferrer' : undefined} onClick={e => {
            if (!link.external) {
              handleNavClick(e, link.href);
            }
          }} className="text-base font-medium text-gray-300 hover:text-brand-cyan transition-colors py-1" data-id="element-325">
                  {link.label}
                </a>)}
              <a href="https://shop.qtap.me/collections/world-cup-2026-smart-t-shirt" target="_blank" rel="noopener noreferrer" className="bg-brand-cyan text-brand-darkest font-bold py-3 px-6 rounded-full text-center mt-3" data-id="element-326">
                Order Now
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}